// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlashSale-module_flashSaleMain___Dli8A {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.FlashSale-module_flashSaleMain___Dli8A .FlashSale-module_flashSaleForm___fGdgB {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.FlashSale-module_flashSaleMain___Dli8A .FlashSale-module_flashSaleForm___fGdgB .FlashSale-module_buttons___chRrQ {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  font-weight: 400;
}
.FlashSale-module_flashSaleMain___Dli8A .FlashSale-module_flashSaleForm___fGdgB .FlashSale-module_flashSaleInput___l0jp_ {
  align-items: flex-end;
  display: flex;
  gap: 10px;
  align-items: start;
}
.FlashSale-module_flashSaleMain___Dli8A .FlashSale-module_flashSaleForm___fGdgB .FlashSale-module_flashSaleInput___l0jp_ .FlashSale-module_switchContainer___XByXz {
  height: 47px;
  display: flex;
  align-items: flex-end;
  gap: 4px;
  padding-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/children/pricing/components/manage-inventory/manage-listing/AdvancedTab/components/FlashSale/FlashSale.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AACD;AACC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AACF;AACE;EACC,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AACH;AAEE;EACC,qBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AAAH;AAEG;EACC,YAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AAAJ","sourcesContent":[".flashSaleMain {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 16px;\r\n\r\n\t.flashSaleForm {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: flex-end;\r\n\r\n\t\t.buttons {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: flex-end;\r\n\t\t\tgap: 4px;\r\n\t\t\tfont-weight: 400;\r\n\t\t}\r\n\r\n\t\t.flashSaleInput {\r\n\t\t\talign-items: flex-end;\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 10px;\r\n\t\t\talign-items: start;\r\n\r\n\t\t\t.switchContainer {\r\n\t\t\t\theight: 47px;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: flex-end;\r\n\t\t\t\tgap: 4px;\r\n\t\t\t\tpadding-bottom: 6px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flashSaleMain": `FlashSale-module_flashSaleMain___Dli8A`,
	"flashSaleForm": `FlashSale-module_flashSaleForm___fGdgB`,
	"buttons": `FlashSale-module_buttons___chRrQ`,
	"flashSaleInput": `FlashSale-module_flashSaleInput___l0jp_`,
	"switchContainer": `FlashSale-module_switchContainer___XByXz`
};
export default ___CSS_LOADER_EXPORT___;
